// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1JTnoXiV9E2UmJVNMWn_26 {\n  font-size: 70%;\n}\n\n._297zaO65fNra1tfAtAZf8E {\n  width: 100%;\n}\n\n._297zaO65fNra1tfAtAZf8E textarea {\n  resize: vertical;\n}\n\n._2k7t-TuKG8h06u6wh0wUCk {\n  padding: 7px 13px;\n  white-space: pre-wrap;\n  word-break: break-word;\n  width: 100%;\n}\n", ""]);
// Exports
exports.locals = {
	"counter": "_1JTnoXiV9E2UmJVNMWn_26",
	"container": "_297zaO65fNra1tfAtAZf8E",
	"textAreaValue": "_2k7t-TuKG8h06u6wh0wUCk"
};
module.exports = exports;
